import { Grid } from "@mui/material";
import { Box, Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material";

const Escola = styled(Grid)(({ theme }) => ({
	transition: "0.2s",
	cursor: "pointer",
	overflow: "hidden",
	position: "relative",
	justifyContent: "center",
	display: "flex",
	"&:hover": {
		transform: "scale(1.1)",
		"&> div > img": {
			opacity: 0.2,
		},
		"&> div > div > h3": {
			opacity: 1,
		},
	},
}));

const Titol = styled(Typography)(({ theme }) => ({
	color: "white",
	fontSize: 28,
	paddingTop: 30,
	paddingBottom: 15,
}));

const InnerEscola = styled(Box)(({ theme }) => ({
	borderRadius: 200,
	width: 250,
	height: 250,
	overflow: "hidden",
	textAlign: "center",
}));

const Overlay = styled(Box)(({ theme }) => ({
	position: "absolute",
	top: "50%",
	right: 0,
	left: 0,
	margin: "auto",
	textAlign: "center",
	"&> h3": {
		color: "white",
		transition: "0.2s",
		fontSize: 30,
		opacity: 0,
	},
}));

const EscolaSingle = (props) => {
	const { escola } = props;
	const { onClick } = props;

	return (
		<Escola item size={{ xs: 12, sm: 4 }} onClick={onClick} key={escola.id}>
			<InnerEscola style={{ backgroundColor: escola.color }}>
				<Titol variant="h3">{escola.nom}</Titol>
				<img
					alt="monigote"
					src={
						"https://api.sinapsisberga.cat/storage/" + escola.imatge
					}
					width={160}
					style={{ transition: "0.2s" }}
				/>
				<Overlay>
					<Typography variant="h3">INSCRIU-TE!</Typography>
				</Overlay>
			</InnerEscola>
		</Escola>
	);
};

export default EscolaSingle;
